import { Box, Typography } from '@mui/material';
import React from 'react';
import Seo from '../components/coreLayout/Seo';

const pageNotFoundSx = {
    container: {
        height: '70vh',
        textAlign: 'center',
        color: 'primary.main',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
    },
} as const;

export default function PageNotFound() {
    return (
        <>
            <Seo
                title="Page Not Found | GSL Aviation"
                description="The page you were looking for could not be found."
                noindex
            />
            <Box sx={pageNotFoundSx.container}>
                <Typography variant="h4" color="primary">
                    404 Error | Page Not Found
                </Typography>
                <Typography>Try using the menu to navigate to our other pages.</Typography>
            </Box>
        </>
    );
}
